<template>
  <div>
    <b-row class="course_container" v-for="(course, index) in courses" :key="index">
      <b-col sm="12" class="course_title_container">
        <p>{{ course.name }}</p>
      </b-col>
      <b-col sm="12">
        <b-row>
          <b-col sm="4" md="4">
            <p>Type de course</p>
            <b-form-radio-group id="btn-radios-2" v-model="course.type" :options="course_types" button-variant="outline-primary" size="sm" name="radio-btn-outline" buttons @input="onCourseTypeUpdate(index)"></b-form-radio-group>
          </b-col>
          <b-col sm="4">
            <b-form-checkbox size="lg" v-model="course.hide_public" style="padding-top: -10px" name="check-button" switch>
              <p style="margin-bottom: 0; font-size: 1rem">Masquer les résultats</p>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" v-if="course.passages_interm.length > 0">
        <p style="text-decoration: underline">Classements intermédiaires</p>
        <div v-for="(inter, index_inter) in course.passages_interm" :key="index_inter">
          <b-form-checkbox switch :id="'checkbox-' + index_inter + '' + course.name" v-model="inter.display" :name="'checkbox-' + index_inter + '' + course.name" value="true" unchecked-value="false">
            Ajouter un onglet pour le classement intermédiaire {{ inter.name }}
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col sm="12">
        <p style="text-decoration: underline">Template</p>
        <b-button size="sm" v-b-toggle="'collapse-' + index" variant="primary">Afficher/Masquer la configuration avancée</b-button>

        <b-collapse :id="'collapse-' + index" class="mt-2">
          <b-card>
            <b-row>
              <b-col sm="9">
                <DraggableBlocks v-if="course.displayedValue.length > 0" :displayedValue="course.displayedValue" @updatePrevisualisation="updatePrevisualisation()"></DraggableBlocks>
                <b-row style="margin-top: 20px">
                  <b-col style="text-align: center">
                    <b-button @click="addDraggableBlock(index)">Ajouter un champs</b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="3" class="available_fields">
                <DraggableFieldsList v-if="fields.length > 0" :fields="fields"></DraggableFieldsList>
              </b-col>
            </b-row>
          </b-card>
        </b-collapse>
      </b-col>

      <b-col sm="12" class="previsualisation_results">
        <PrevisualisationResults :results="course.formated_data" :fields="course.displayedValue"></PrevisualisationResults>
      </b-col>
    </b-row>
    <b-row class="mise_en_ligne_container">
      <b-col>
        <p style="text-align: center"><b-button @click="launchUpload()">Mettre en ligne</b-button></p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Course_Formater } from "@/classes/course_formater.js";
import DraggableBlocks from "@/component/Import/Formater/DraggableBlocks.vue";
import DraggableFieldsList from "@/component/Import/Formater/DraggableFieldsList.vue";
import PrevisualisationResults from "@/component/Import/Formater/PrevisualisationResults.vue";
export default {
  props: ["raw_resultats", "old_course_formater", "old_passages_inter"],
  components: {
    DraggableBlocks,
    DraggableFieldsList,
    PrevisualisationResults,
  },
  data() {
    return {
      resultats: [],
      fields: [],
      courses: [],
      course_types: [
        { value: "normal", text: "Normal" },
        { value: "temps_reel", text: "Temps réel" },
        { value: "duo", text: "Duo" },
      ],
      old_champs_imported: false,
    };
  },
  watch: {
    raw_resultats: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.resultats = this.raw_resultats;
        this.buildFields();
        this.buildCourses();
        if (this.old_course_formater && !this.old_champs_imported) {
          this.import_old_course_formater();
        }
        if (this.old_passages_inter) {
          this.import_old_passages_inter();
        }
      },
    },
  },
  methods: {
    import_old_course_formater() {
      if (this.courses.length > 0 && this.old_course_formater.length > 0) {
        for (var i = 0; i < this.courses.length; i++) {
          for (var j = 0; j < this.old_course_formater.length; j++) {
            if (this.courses[i] && this.courses[i].name === this.old_course_formater[j].nom_course) {
              if (this.old_course_formater[j].hide_public) {
                this.courses[i].hide_public = this.old_course_formater[j].hide_public;
              }
              this.courses[i].clm_fields = this.old_course_formater[j].clm_fields;
              this.courses[i].displayedValue = this.old_course_formater[j].displayedValue;
              this.courses[i].type = this.old_course_formater[j].type;
            }
          }
        }
      }
    },
    import_old_passages_inter() {
      if (this.courses.length > 0 && this.old_passages_inter.length > 0) {
        for (var i = 0; i < this.courses.length; i++) {
          for (var j = 0; j < this.old_passages_inter.length; j++) {
            if (this.courses[i].name === this.old_passages_inter[j].course) {
              for (var k = 0; k < this.courses[i].passages_interm.length; k++) {
                for (var l = 0; l < this.old_passages_inter[j].points.length; l++) {
                  if (this.courses[i].passages_interm[k].name === this.old_passages_inter[j].points[l].name) {
                    this.courses[i].passages_interm[k] = this.old_passages_inter[j].points[l];
                  }
                }
              }
            }
          }
        }
      }
    },
    /* On click bouton mise en ligne, emit listes courses */
    launchUpload() {
      this.$emit("launchUpload", this.courses);
    },

    /* Lorsque l'on change le type de course */
    onCourseTypeUpdate(index) {
      this.courses[index].updateType(this.fields);
      this.updatePrevisualisation();
      this.$forceUpdate();
    },

    /* Ajoute un bloc à la liste des champs d'une course */
    addDraggableBlock(index) {
      this.courses[index].displayedValue.push({
        align: "centre",
        sexColor: "non",
        entete: "",
        values: [],
      });
    },

    /* Met a jour les données formatées d'une course, et update tableau de prévisualisation */
    updatePrevisualisation() {
      for (var i = 0; i < this.courses.length; i++) {
        this.courses[i].updateFormatedData(this.resultats);
      }
    },

    /* Construit la liste des champs disponible d'après les entetes de l'export GMCAP */
    buildFields() {
      this.fields = [];
      var first_row = this.resultats[0];
      for (var field in first_row) {
        this.fields.push({ name: field });
      }
    },

    /* Construit la liste des courses et initialise le template par défaut */
    buildCourses() {
      this.courses = [];
      for (var i = 0; i < this.resultats.length; i++) {
        var isNew = true;
        for (var j = 0; j < this.courses.length; j++) {
          if (this.courses[j].name === this.resultats[i]["Course"] && this.resultats[i]["Course"] != null) {
            isNew = false;
            break;
          }
        }
        if (isNew && this.resultats[i]["Course"]) {
          let course = new Course_Formater(this.resultats[i]["Course"]);
          course.setDefaultDisplayedValue();
          course.setDefaultFormatedData(this.resultats);
          course.findPassageInterm(this.resultats, this.fields);
          this.courses.push(course);
        }
      }
    },
  },
};
</script>

<style>
.card {
  background-color: transparent !important;
}
.btn-group .btn-outline-primary:hover {
  cursor: pointer;
}
.btn-group .btn-outline-primary {
  background-color: white !important;
  border: 1px solid #f29200 !important;
  color: #f29200 !important;
}
.btn-group .btn-outline-primary.active {
  background-color: #f29200 !important;
  border: 1px solid #f29200 !important;
  color: white !important;
}
.course_container {
  font-size: 12px;
  background-color: #e2e2e2;
  border: 1px solid #222;
  border-radius: 3px;
  margin: 20px 5px;
  padding-top: 0;
  padding-bottom: 10px;
  overflow: hidden;
}

.course_container {
  margin-bottom: 0;
  line-height: 38px;
  font-weight: bold;
  text-align: left;
}

.course_title_container {
  color: white;
  background-color: #222;
  padding: 7px;
  margin-bottom: 15px;
}

.course_title_container p {
  font-size: 1.3em;
  line-height: 1.3em;
  margin-bottom: 0;
  text-align: left;
}

.available_fields {
  height: 400px !important;
  overflow: auto;
}
.list-group-item {
  cursor: grab !important;
  height: 30px !important;
  line-height: 30px;
  padding: 0 0 0 10px !important;
  margin: 2px 0 !important;
  overflow: hidden;
}

.list-group-item button {
  padding: 0 5px;
  border-radius: 0;
  height: 100%;
  font-size: 12px;
  float: right;
  z-index: 10000;
  position: absolute;
  right: 0;
}

.mise_en_ligne_container {
  padding: 50px 0;
}
</style>